<template>
    <div>
        <rkm-area
            type="fieldset"
            title="Filtros"
        >
            <rkm-form ref="Form">
                <rkm-row class="flex-nowrap">
                    <rkm-col cols="3">
                        <rkm-form-date-picker
                            :range-inline="false"
                            label="Data"
                            v-model="model.dataSaida"
                            :validations="validations.dataSaida"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <rkm-form-select
                            :options="municipios"
                            label="Município"
                            show-default-option
                            text-field="nome"
                            v-model="model.municipioId"
                            value-field="id"
                            :validations="validations.municipio"
                            default-option-text="Todos"
                            @change="loadFields('municipioId')"
                        />
                    </rkm-col>

                    <rkm-col class="flex-grow-1">
                        <rkm-form-select
                            :options="destinos"
                            label="Local da consulta"
                            show-default-option
                            text-field="descricao"
                            v-model="model.destinoId"
                            value-field="id"
                            default-option-text="Todos"
                            :disabled="!model.municipioId"
                            @change="loadFields('destinoId')"
                        />
                    </rkm-col>

                    <rkm-col cols="auto">
                        <rkm-button
                            :label="false"
                            color="primary"
                            @click="$refs.Form.validate(search)"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="resetForm()"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <rkm-table
            v-if="isSearch"
            :items="items"
            :fields="fields"
            sort-by="horarioSaida"
        >

            <template v-slot:cell(actions)="{ item }">

                <rkm-button
                    @click.stop="$router.push({ name: 'transporte-paciente-transferencia-paciente-create', params: { item: item } })"
                    color="primary"
                    title="Transferir"
                    small
                >
                    <rkm-icon icon="share" />
                </rkm-button>
            </template>
        </rkm-table>
    </div>
</template>

<script>

// Vuex.
import { mapActions } from 'vuex'

// Mixins.
import { error, repository, object, data, stringCase} from '@/mixins'

// Filters.
import format from '@/filters/formats'

// Moment.
import moment from 'moment'

// Enums.
import preferenciaNome from '@/enums/cadastro/cidadao/preferenciaNome'

export default {
    computed: {
        validations() {

            return {
                dataSaida: { required: true },
            }
        },
        fields() {

            const fields = [
                {
                    key: 'dataSaida',
                    label: 'Data da saída',
                    searchable: true,
                    sortable: true,
                    class: 'col-min text-center',
                },
                {
                    key: 'horarioSaida',
                    label: 'Horário da saída',
                    searchable: true,
                    sortable: true,
                    class: 'col-min text-center',
                },
                {
                    key: 'veiculoNome',
                    label: 'Veículo',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'municipioNome',
                    label: 'Município ',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'motoristaNome',
                    label: 'Motorista',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'protocolo',
                    label: 'Protocolo',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'jornada',
                    label: 'Jornada',
                    searchable: true,
                    sortable: true
                },
                {
                    key: 'quantidadePacientes',
                    label: 'Pacientes',
                    class: 'col-min text-center',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'quantidadeAcompanhantes',
                    label: 'Acompanhantes',
                    class: 'col-min text-center',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'capacidade',
                    label: 'Capacidade',
                    class: 'col-min text-center',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'vagasDisponiveis',
                    label: 'Vagas',
                    class: 'col-min text-center',
                    searchable: true,
                    sortable: true,
                },
                {
                    key: 'actions',
                    label: 'Ações',
                    class: 'col-min text-center'
                }
            ];

            return fields
        },
    },
    created() {

        this.repositories = {
            transferencia: this.getConectaSusRepository('transportePaciente.transferencia'),
            agendar: this.getConectaSusRepository('transportePaciente.agendar')
        }

        this.load()
    },
    data: () => ({
        form: [],
        items: [],
        filterDefault: {},
        model: {
            dataSaida: null,
            municipioId: null,
            destinoId: null,
        },
        municipios: [],
        destinos: [],
        fieldMap: [
            'data',
            'municipioId',
            'destinoId',
        ],
        isSearch: false,
        enums: {
            preferenciaNome,
        }
    }),
    filters: {
        ...format,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {

            this.setLoading()

            this.repositories.transferencia.create()
                .then(({ data }) => {

                    this.form = data.form
                    this.model = data.model

                    this.filterDefault = {
                        form: this.clone(this.form),
                        model: this.clone(this.model)
                    }

                    this.municipios = data.form.municipios
                    this.destinos = data.form.destinos
                    this.setDefaultValues()
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        loadFields(field) {

            this.setLoading()

            this.setFields(field)

            this.repositories.transferencia.loadFields(this.getSearchParams())
                .then(({ data }) => {

                    this.municipios = data.form.municipios
                    this.destinos = data.form.destinos
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        getSearchParams() {

            const params = this.clone(this.model)

            this.formateDates(params, ['dataSaida'], 'YYYY-MM-DD')

            return this.camelObjectKeysToSnakeRecursive(params)
        },
        setFields(value) {

            this.isSearch = false

            const index = this.fieldMap.indexOf(value) + 1;

            for (let i = index; i < this.fieldMap.length; i++) {

                const field = this.fieldMap[i];

                if (this.model[field] !== null) {

                    for (const ref of Object.values(this.$refs)) {

                        if (ref.validate) {
                            ref.resetValidator();
                        }
                    }

                    this.$set(this.model, field, null);
                }
            }
        },
        resetForm() {

            this.form = this.clone(this.filterDefault.form)
            this.model = this.clone(this.filterDefault.model)
            this.isSearch = false
            this.items = []

            this.setDefaultValues()

            if (this.$refs.Form) {

                this.$refs.Form.resetValidator()
            }
        },
        setDefaultValues() {

            this.model.dataSaida = moment(this.form.dataAtual, 'DD/MM/YYYY').toDate()
        },
        search() {

            this.setLoading()

            this.repositories.transferencia.list(this.getSearchParams())
                .then(({ data }) => {

                    this.items = data.agendamentos
                    this.isSearch = true
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
    },
    mixins: [ error, repository, object, data, stringCase ],
    watch: {
        'model.dataSaida': function (data) {

            if (data) {

                this.loadFields('data')
            }
        },
    }
};

</script>

<style scoped>
.dataSaida { width:150px }
.table-td {
    background: #f1f1f1;
    padding: 0 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
}
</style>